import { Avatar, Typography } from 'shared/ui'
import { type IAvatarInfo } from 'shared/ui/Avatar'
import styles from './styles.module.scss'

type MemberNameCellProps = {
  avatarInfo: IAvatarInfo
  fullName: string
  email: string
}

export const MemberNameCell = ({ avatarInfo, fullName, email }: MemberNameCellProps) => {
  return (
    <div className={styles.name}>
      <Avatar info={avatarInfo} size={32} fontSize={14} />
      <div className={styles.nameInfo}>
        <Typography
          variant='body-md-regular'
          ariaLabel='MemberFullName'
          tooltipProps={{
            label: fullName,
          }}
          ellipsis
        >
          {fullName}
        </Typography>
        <Typography
          variant='body-sm-regular'
          ariaLabel='MemberEmail'
          color='var(--content-primary-tertiary)'
          tooltipProps={{
            label: email,
          }}
          ellipsis
        >
          {email}
        </Typography>
      </div>
    </div>
  )
}
